import { useState } from "react";
import { Menu, X } from "lucide-react";
import { Wordmark } from "./Logo";
import { scrollToId } from "../../hooks/useLenis";
import { waLink } from "../../lib/content";
import { useLang } from "../../lib/i18n";

export const Nav = ({ contact, sections = [], logo, banner = null }) => {
  const [open, setOpen] = useState(false);
  const { t, lang, toggle } = useLang();
  const ids = ["schedule", ...sections.filter((s) => s.visible && s.id !== "marquee").map((s) => s.id)];
  const LINKS = ids.map((id) => [id, t.nav[id]]);
  const go = (id) => {
    setOpen(false);
    scrollToId(id);
  };
  return (
    <header className="fixed inset-x-0 top-0 z-50 border-b border-white/[0.06] bg-[#0B0B0E]/70 backdrop-blur-xl" data-testid="site-nav">
      {banner}
      <div className="mx-auto flex h-16 max-w-[1440px] items-center justify-between px-5 lg:px-10">
        <button onClick={() => go("schedule")} data-testid="nav-brand-logo" aria-label="MRVA Productions home">
          <Wordmark src={logo} />
        </button>
        <nav className="hidden items-center gap-1 md:flex">
          {LINKS.map(([id, label]) => (
            <button key={id} onClick={() => go(id)} data-testid={`nav-link-${id}`}
              className="rounded-full px-4 py-2 font-mono text-[12px] uppercase tracking-[0.18em] text-zinc-300 transition-colors hover:bg-white/5 hover:text-white">
              {label}
            </button>
          ))}
        </nav>
        <div className="flex items-center gap-2">
          <button onClick={toggle} data-testid="lang-toggle-btn" aria-label={t.langSwitchLabel} title={t.langSwitchLabel}
            className={`grid h-10 min-w-10 place-items-center rounded-full border border-white/15 px-3 text-[13px] font-bold text-white transition-colors hover:border-accent hover:text-accent ${lang === "ar" ? "font-mono" : "font-arabic"}`}>
            {t.langSwitch}
          </button>
          <a href={waLink(contact, "", lang)} target="_blank" rel="noreferrer" data-testid="nav-book-trial-btn"
            className="hidden rounded-full bg-accent px-4 py-2 text-[13px] font-bold text-onaccent transition-transform hover:-translate-y-0.5 active:scale-95 sm:inline-block">
            {t.bookTrial}
          </a>
          <button className="grid h-10 w-10 place-items-center rounded-full border border-white/10 text-white md:hidden"
            onClick={() => setOpen((v) => !v)} data-testid="nav-mobile-menu-btn" aria-label="Menu">
            {open ? <X size={18} /> : <Menu size={18} />}
          </button>
        </div>
      </div>
      {open && (
        <nav className="border-t border-white/[0.06] bg-[#0B0B0E] px-5 pb-5 pt-2 md:hidden" data-testid="nav-mobile-menu">
          {LINKS.map(([id, label], i) => (
            <button key={id} onClick={() => go(id)} data-testid={`nav-mobile-link-${id}`}
              className="flex w-full items-baseline justify-between border-b border-white/[0.06] py-4 text-start font-display text-2xl font-bold text-white">
              {label}
              <span className="font-mono text-xs text-zinc-500">0{i + 1}</span>
            </button>
          ))}
        </nav>
      )}
    </header>
  );
};
